"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const prop_types_1 = require("prop-types");
const react_1 = __importDefault(require("react"));
const constants_1 = require("../../utilities/constants");
const measurements_1 = require("../../utilities/measurements");
const EllipsizedLabel = _ref => {
  let {
    fontSize = constants_1.DEFAULT_FONT_SIZE,
    fontFamily = constants_1.FONT_FAMILY,
    maxWidth = 200,
    maxLines = 3,
    dominantBaseline = 'auto',
    label = ''
  } = _ref;
  const lineSize = line => (0, measurements_1.textDimensions)({
    text: line,
    fontSize,
    fontFamily
  }).width;
  const truncateLabel = label => {
    let truncated = label.split(' ')[0];
    while (lineSize(`${truncated}...`) > maxWidth) {
      if (truncated.length === 0) {
        return react_1.default.createElement("tspan", null);
      }
      truncated = truncated.substring(0, truncated.length - 1);
    }
    return [react_1.default.createElement("tspan", {
      key: 0,
      dx: 0,
      dy: 0
    }, `${truncated}...`)];
  };
  const splitLine = labelWords => {
    const allocatedLines = Array.apply(null, Array(maxLines));
    const ellipsizeLastLine = lines => {
      let lastLine = lines[lines.length - 1];
      while (lineSize(`${lastLine}...`) > maxWidth) {
        lastLine = lastLine.substring(0, lastLine.lastIndexOf(' '));
        if (lastLine === '') {
          break;
        }
      }
      lines[lines.length - 1] = `${lastLine}...`;
    };
    const lines = allocatedLines.map(() => {
      if (!labelWords) {
        return '';
      }
      let line = labelWords.shift();
      if (lineSize(line) > maxWidth) {
        labelWords = '';
        return '...';
      }
      while (lineSize(`${line} ${labelWords[0]}`) <= maxWidth) {
        if (labelWords.length === 0) {
          break;
        }
        line += ` ${labelWords.shift()}`;
      }
      return line;
    }).filter(line => line !== undefined);
    if (labelWords.length > 0) {
      ellipsizeLastLine(lines);
    }
    return lines;
  };
  const createSubLabels = lines => {
    const lineHeight = (0, measurements_1.textDimensions)({
      text: lines[0],
      fontSize,
      fontFamily
    }).height || fontSize;
    return lines.map((line, i) => {
      let yOffset = lineHeight;
      if (i === 0) {
        switch (dominantBaseline) {
          case 'auto':
            yOffset = -(lines.length - i - 1) * lineHeight;
            break;
          case 'middle':
            yOffset = (i + 0.5 - lines.length / 2) * lineHeight;
            break;
          case 'hanging':
            yOffset = i * lineHeight;
            break;
          default:
            yOffset = (lines.length - i - 1) * lineHeight;
        }
      }
      return react_1.default.createElement("tspan", {
        key: i,
        dy: yOffset,
        dx: i === 0 ? 0 : -lineSize(lines[i - 1])
      }, line);
    });
  };
  const labelWords = label.split(' ');
  if (labelWords.length === 0) {
    return;
  }
  if (lineSize(labelWords[0]) > maxWidth) {
    return truncateLabel(label);
  }
  const lines = splitLine(labelWords);
  return react_1.default.createElement(react_1.default.Fragment, null, createSubLabels(lines));
};
EllipsizedLabel.propTypes = {
  /**
   * Array of labels
   */
  label: prop_types_1.string.isRequired,
  /**
   * font size
   */
  fontSize: prop_types_1.number,
  /**
   * font family
   */
  fontFamily: prop_types_1.string,
  /**
   * maximum width of labels
   */
  maxWidth: prop_types_1.number,
  /**
   * maximum number of lines per label
   */
  maxLines: prop_types_1.number,
  /**
   * dominant baseline: this affects vertical positioning
   */
  dominantBaseline: prop_types_1.string
};
exports.default = EllipsizedLabel;